import * as ActionTypes from '../constants/actionTypes'
import { login, param } from './app'
import { loginApp } from '../api/auth'
import { getParams } from '../api/different'

export const changeFormFields = formFieldsChange => ({
  type: ActionTypes.LOGIN_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const sendLoginRequest = values => (dispatch) => {
  dispatch({ type: ActionTypes.LOGIN_LOGIN_LOAD })
  loginApp(values).then((res) => {
    dispatch({ type: ActionTypes.LOGIN_LOGIN_SUCCEED })

    dispatch(login({ sessionId: res.result.session_id, userId: res.result.user_id, isEPO: res.result.is_epo }))
    // dispatch(login({ accessToken: values.login }))
  }).catch((err) => {
    dispatch({ type: ActionTypes.LOGIN_LOGIN_FAIL, loginError: err.message })
  })
  // window.setTimeout(() => {
  //   dispatch({ type: ActionTypes.LOGIN_LOGIN_SUCCEED })
  //   dispatch(login({ accessToken: values.email }))
  //   // dispatch({ type: ActionTypes.LOGIN_LOGIN_FAIL, loginError: 'This is a login error.' })
  // }, 1000)
}

export const sendParamRequest = () => (dispatch) => {
  getParams().then((resParams) => {
    dispatch(param({ params: resParams.result }))
    // dispatch(login({ sessionId: res.result.session_id }))
    console.log(resParam)
  }).catch((err) => {

  })
}



// WEBPACK FOOTER //
// src/actions/login.js